//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afghanistan",
  ax: "Åland",
  al: "Albanië",
  dz: "Algerije",
  as: "Amerikaans-Samoa",
  vi: "Amerikaanse Maagdeneilanden",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarctica",
  ag: "Antigua en Barbuda",
  ar: "Argentinië",
  am: "Armenië",
  aw: "Aruba",
  au: "Australië",
  az: "Azerbeidzjan",
  bs: "Bahama’s",
  bh: "Bahrein",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Belarus",
  be: "België",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnië en Herzegovina",
  bw: "Botswana",
  bv: "Bouveteiland",
  br: "Brazilië",
  io: "Brits Indische Oceaanterritorium",
  vg: "Britse Maagdeneilanden",
  bn: "Brunei",
  bg: "Bulgarije",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodja",
  ca: "Canada",
  bq: "Caribisch Nederland",
  cf: "Centraal-Afrikaanse Republiek",
  cl: "Chili",
  cn: "China",
  cx: "Christmaseiland",
  cc: "Cocoseilanden",
  co: "Colombia",
  km: "Comoren",
  cg: "Congo-Brazzaville",
  cd: "Congo-Kinshasa",
  ck: "Cookeilanden",
  cr: "Costa Rica",
  cu: "Cuba",
  cw: "Curaçao",
  cy: "Cyprus",
  dk: "Denemarken",
  dj: "Djibouti",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  de: "Duitsland",
  ec: "Ecuador",
  eg: "Egypte",
  sv: "El Salvador",
  gq: "Equatoriaal-Guinea",
  er: "Eritrea",
  ee: "Estland",
  sz: "eSwatini",
  et: "Ethiopië",
  fo: "Faeröer",
  fk: "Falklandeilanden",
  fj: "Fiji",
  ph: "Filipijnen",
  fi: "Finland",
  fr: "Frankrijk",
  gf: "Frans-Guyana",
  pf: "Frans-Polynesië",
  tf: "Franse Gebieden in de zuidelijke Indische Oceaan",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgië",
  gh: "Ghana",
  gi: "Gibraltar",
  gd: "Grenada",
  gr: "Griekenland",
  gl: "Groenland",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinee",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  ht: "Haïti",
  hm: "Heard en McDonaldeilanden",
  hn: "Honduras",
  hu: "Hongarije",
  hk: "Hongkong SAR van China",
  ie: "Ierland",
  is: "IJsland",
  in: "India",
  id: "Indonesië",
  iq: "Irak",
  ir: "Iran",
  im: "Isle of Man",
  il: "Israël",
  it: "Italië",
  ci: "Ivoorkust",
  jm: "Jamaica",
  jp: "Japan",
  ye: "Jemen",
  je: "Jersey",
  jo: "Jordanië",
  ky: "Kaaimaneilanden",
  cv: "Kaapverdië",
  cm: "Kameroen",
  kz: "Kazachstan",
  ke: "Kenia",
  kg: "Kirgizië",
  ki: "Kiribati",
  um: "Kleine afgelegen eilanden van de Verenigde Staten",
  kw: "Koeweit",
  hr: "Kroatië",
  la: "Laos",
  ls: "Lesotho",
  lv: "Letland",
  lb: "Libanon",
  lr: "Liberia",
  ly: "Libië",
  li: "Liechtenstein",
  lt: "Litouwen",
  lu: "Luxemburg",
  mo: "Macau SAR van China",
  mg: "Madagaskar",
  mw: "Malawi",
  mv: "Maldiven",
  my: "Maleisië",
  ml: "Mali",
  mt: "Malta",
  ma: "Marokko",
  mh: "Marshalleilanden",
  mq: "Martinique",
  mr: "Mauritanië",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexico",
  fm: "Micronesia",
  md: "Moldavië",
  mc: "Monaco",
  mn: "Mongolië",
  me: "Montenegro",
  ms: "Montserrat",
  mz: "Mozambique",
  mm: "Myanmar (Birma)",
  na: "Namibië",
  nr: "Nauru",
  nl: "Nederland",
  np: "Nepal",
  ni: "Nicaragua",
  nc: "Nieuw-Caledonië",
  nz: "Nieuw-Zeeland",
  ne: "Niger",
  ng: "Nigeria",
  nu: "Niue",
  kp: "Noord-Korea",
  mk: "Noord-Macedonië",
  mp: "Noordelijke Marianen",
  no: "Noorwegen",
  nf: "Norfolk",
  ug: "Oeganda",
  ua: "Oekraïne",
  uz: "Oezbekistan",
  om: "Oman",
  tl: "Oost-Timor",
  at: "Oostenrijk",
  pk: "Pakistan",
  pw: "Palau",
  ps: "Palestijnse gebieden",
  pa: "Panama",
  pg: "Papoea-Nieuw-Guinea",
  py: "Paraguay",
  pe: "Peru",
  pn: "Pitcairneilanden",
  pl: "Polen",
  pt: "Portugal",
  pr: "Puerto Rico",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  ru: "Rusland",
  rw: "Rwanda",
  kn: "Saint Kitts en Nevis",
  lc: "Saint Lucia",
  vc: "Saint Vincent en de Grenadines",
  bl: "Saint-Barthélemy",
  mf: "Saint-Martin",
  pm: "Saint-Pierre en Miquelon",
  sb: "Salomonseilanden",
  ws: "Samoa",
  sm: "San Marino",
  st: "Sao Tomé en Principe",
  sa: "Saoedi-Arabië",
  sn: "Senegal",
  rs: "Servië",
  sc: "Seychellen",
  sl: "Sierra Leone",
  sg: "Singapore",
  sh: "Sint-Helena",
  sx: "Sint-Maarten",
  si: "Slovenië",
  sk: "Slowakije",
  sd: "Soedan",
  so: "Somalië",
  es: "Spanje",
  sj: "Spitsbergen en Jan Mayen",
  lk: "Sri Lanka",
  sr: "Suriname",
  sy: "Syrië",
  tj: "Tadzjikistan",
  tw: "Taiwan",
  tz: "Tanzania",
  th: "Thailand",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad en Tobago",
  td: "Tsjaad",
  cz: "Tsjechië",
  tn: "Tunesië",
  tr: "Turkije",
  tm: "Turkmenistan",
  tc: "Turks- en Caicoseilanden",
  tv: "Tuvalu",
  uy: "Uruguay",
  vu: "Vanuatu",
  va: "Vaticaanstad",
  ve: "Venezuela",
  gb: "Verenigd Koninkrijk",
  ae: "Verenigde Arabische Emiraten",
  us: "Verenigde Staten",
  vn: "Vietnam",
  wf: "Wallis en Futuna",
  eh: "Westelijke Sahara",
  zm: "Zambia",
  zw: "Zimbabwe",
  za: "Zuid-Afrika",
  gs: "Zuid-Georgia en Zuidelijke Sandwicheilanden",
  kr: "Zuid-Korea",
  ss: "Zuid-Soedan",
  se: "Zweden",
  ch: "Zwitserland",
};
